import { fetchUserAction } from "../Redux/userReducer"

export const userFetch = () => {
    return dispatch => {
        fetch('https://jsonplaceholder.typicode.com/users')
            .then(response => response.json())
            .then(json => dispatch(fetchUserAction(json)));
    }
}